module.exports = __webpack_public_path__ + "static/img/mamanvogue-03.1ec1a54.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mamanvogue-03.webp
// module id = 114
// module chunks = 0